export const MAX_PROJECT_PRIORITIES = 10;
export const PROJECT_ISSUES_STALE_HOUR_LIMIT = 1; // the hours that the data can sit in the local store - after this the data will be refreshed

export const SETUP_IMPORT = 'Select a security key and then import projects';
export const HAS_PROJECTS_TO_IMPORT = 'You have projects to import';
export const NO_PROJECTS_TO_IMPORT = 'There are no new projects to import - the current list is up to date';

export const ISSUE_TYPE_RELEASE = 'Release';



// WEBPACK FOOTER //
// ./constants/project.js